import React, { useRef, useEffect } from 'react';

import { useLayoutContext } from '@ott/layout-context';

import FadeIn from 'src/components/elements/FadeIn';

import { S3_IMAGES_URL } from '../../constants';
import { ORBITS } from './constants';

import { motion, useInView, useAnimation } from 'framer-motion';

import styles from './OrbitsBlock.scss';

const OrbitsBlock = () => {
  const ref = useRef(null);
  const inViewport = useInView(ref);
  const control = useAnimation();
  const { isMobile } = useLayoutContext();

  const variants = {
    initial: { opacity: 0 },
    animate: { opacity: 0.7, transition: { duration: 1.5 } },
  };

  useEffect(() => {
    if (inViewport) {
      control.start('animate');
    }
  }, [control, inViewport]);

  return (
    <div className={styles.orbitsBlock}>
      <div className={styles.orbits}>
        <motion.img
          ref={ref}
          className={styles.solarSun}
          src={`${S3_IMAGES_URL}planets_for_orbits/solar_sun.webp`}
          alt="solar-sun"
          variants={variants}
          initial="initial"
          animate={control}
        />
        {ORBITS.map((orbit) => (
          <orbit.src key={orbit.id} className={styles[`orbit${orbit.id}`]} />
        ))}
      </div>

      <div className={styles.titleWrapper}>
        <FadeIn className={styles.title}>
          <span className={styles.titleThin}>Launch your {isMobile && <br />} rewards</span>
        </FadeIn>
        <FadeIn className={styles.title} delay={1}>
          <span className={styles.titleThin}>into a customized</span>
        </FadeIn>
        <FadeIn className={styles.title} delay={1.5}>
          <span>Planetary system</span>
        </FadeIn>
      </div>
    </div>
  );
};

export default OrbitsBlock;
